import { Box, Link, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const HeaderWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.white,
    borderBottom: `1px solid ${palette.border.default}`,
  };
});

export const HeaderContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    minHeight: '72px',
    maxHeight: '80px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px',
    },
  };
});

export const HeaderLeftBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  };
});

export const HeaderRightBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  };
});

export const HeaderLink = styled(Link)(({ theme }: { theme: Theme }) => {
  return {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '19px',
    cursor: 'pointer',
    textDecoration: 'none',

    '&:hover': {
      color: palette.primary.purple900,
    },
  };
});

export const LogoWrapper = styled(Box)({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
});
